import { mapperEventAgendaSection } from '../event-agenda-section/mapper-event-agenda-section'
import { mapperEventLocation } from '../event-location/mapper-event-location'

/**
 * BlockEventFormBlock
 * @param {Object} data, content data
 * @return {Object} normalized data
 */
const mapSection = (item) => {
  const contentType = item?.contentType || ''

  switch (contentType) {
    case 'EventAgendaSection': {
      return { agenda: mapperEventAgendaSection(item) }
    }
    case 'EventLocation': {
      return { location: mapperEventLocation(item) }
    }
    default: {
      return {}
    }
  }
}

export const mapperEventFormBlock = (data: any) => {
  if (!data) {
    return null
  }
  return {
    id: data.sys?.id || '',
    sys: data.sys || null,
    contentType: data.contentType,
    title: data.title || '',
    description: data.formBlockDescription || {},
    ...mapSection(data.eventAgendaOrLocationSection)
  }
}
